import { Action } from 'redux';
import _ from 'underscore';

import {
  isSetAndSavePreviousFilterPanelVisibilityAction,
  isSetFromPreviousFilterPanelVisibiltyAction,
  isUpdateExplorerDisplayModeInternalAction,
  isUpdateFilterPanelVisibilityAction,
} from '../actions/DisplaySettingsActions';
import { isRefreshSessionInfoAction } from '../actions/RefreshSessionInfoAction';
import { DisplaySettingsState } from '../state/DisplaySettingsState';

/*
 * Initial display mode is undefined because we want to make sure the session doesn't overwrite
 * the mode if the URL already did. If it were set to a defined value, the session info handler in
 * the reducer wouldn't know if the state was defined because it was the default, vs. because it
 * was set by the URL or the user.
 *
 * This _should_ be okay because the applySessionInfo action is going to happen before any UI
 * components actually look at the state (because the session info is fetched before anything else
 * in the app can be loaded).
 *
 * If it does end up being a problem, we can change the boolean to `displayModeUpdated`, which
 * would be set to true whenever any action updates the display mode. Then, the session info handler
 * would not update from the session after that boolean has been set to true.
 */
export const DefaultDisplaySettingsState: DisplaySettingsState = {
  showFilterPanel: false,
  explorerDisplayMode: undefined,
  explorerDisplayModeInitializedFromSession: false,
  previousShowFilterPanel: undefined
};

export function displaySettingsReducer(
  previousState: DisplaySettingsState = DefaultDisplaySettingsState,
  action: Action = null
): DisplaySettingsState {

  if (isRefreshSessionInfoAction(action)) {
    const displayModeFromSession = action.sessionInfo && action.sessionInfo.user && action.sessionInfo.user.displayMode;
    const canUpdateDisplayModeFromSession =
        !previousState.explorerDisplayModeInitializedFromSession &&
        previousState.explorerDisplayMode === undefined;

    if (canUpdateDisplayModeFromSession && displayModeFromSession) {
      return {
        ...previousState,
        explorerDisplayMode: displayModeFromSession,
        explorerDisplayModeInitializedFromSession: true
      };
    } else {
      return previousState;
    }
  }

  if (isUpdateExplorerDisplayModeInternalAction(action)) {
    if (action.explorerDisplayMode !== previousState.explorerDisplayMode) {
      return {
        ...previousState,
        explorerDisplayMode: action.explorerDisplayMode
      };
    }
  }

  else if (isUpdateFilterPanelVisibilityAction(action)) {
    if (action.showFilterPanel !== previousState.showFilterPanel) {
      return {
        ...previousState,
        showFilterPanel: action.showFilterPanel
      };
    }
  }

  if (isSetAndSavePreviousFilterPanelVisibilityAction(action)) {
    if (_.isUndefined(previousState.previousShowFilterPanel)) {
      return {
        ...previousState,
        showFilterPanel: action.showFilterPanel,
        previousShowFilterPanel: previousState.showFilterPanel
      };
    }
  }

  if (isSetFromPreviousFilterPanelVisibiltyAction(action)) {
    if (!_.isUndefined(previousState.previousShowFilterPanel)) {
      return {
        ...previousState,
        showFilterPanel: previousState.previousShowFilterPanel,
        previousShowFilterPanel: undefined
      };
    }
  }

  return previousState;
}
